export default {
  list: [
    { title: 'labels.saturday', value: 'SATURDAY' },
    { title: 'labels.sunday', value: 'SUNDAY' },
    { title: 'labels.monday', value: 'MONDAY' },
    { title: 'labels.tuesday', value: 'TUESDAY' },
    { title: 'labels.wednesday', value: 'WEDNESDAY' },
    { title: 'labels.thursday', value: 'THURSDAY' },
    { title: 'labels.friday', value: 'FRIDAY' },
  ],
  values: {
    SATURDAY: 'SATURDAY',
    SUNDAY: 'SUNDAY',
    MONDAY: 'MONDAY',
    TUESDAY: 'TUESDAY',
    WEDNESDAY: 'WEDNESDAY',
    THURSDAY: 'THURSDAY',
    FRIDAY: 'FRIDAY',
  },
};
